import Modal, { ModalProps as TModalProps } from './Modal'
export type ModalProps = TModalProps
export default Modal
